// extracted by mini-css-extract-plugin
export default {"wrapper":"Checkbox_wrapper__f2VLQ","checkbox":"Checkbox_checkbox__71xI9"};